import {withLegacyReceiptFallbacks} from './accountingEntries.js';
import {roundMoney, toAmount} from '../services/billingService.js';
export function calculatePeriodAccounting(entries = [], from, to) {
  const result = {roomRevenue: 0, foodRevenue: 0, laundryRevenue: 0, extraRevenue: 0,
    damageRevenue: 0, grossRevenue: 0, discount: 0, gst: 0, grandRevenue: 0,
    totalPaid: 0, paymentModes: {}, roomRevenueByRoom: {}};
  for (const entry of withLegacyReceiptFallbacks(entries)) {
    if (!entry.businessDate || entry.businessDate < from || entry.businessDate > to) continue;
    const amount = toAmount(entry.amount);
    if (entry.entryType === 'revenue') {
      const category = entry.category;
      const field = {room:'roomRevenue',food:'foodRevenue',laundry:'laundryRevenue',extra:'extraRevenue',damage_charge:'damageRevenue'}[category];
      if (field) {result[field] += amount; result.grossRevenue += amount;}
      if (category === 'room' && entry.room) result.roomRevenueByRoom[entry.room] = roundMoney(toAmount(result.roomRevenueByRoom[entry.room]) + amount);
    }
    if (entry.entryType === 'adjustment' && entry.category === 'discount') result.discount += amount;
    if (entry.entryType === 'adjustment' && entry.category === 'gst') result.gst += amount;
    if (entry.entryType === 'payment' || entry.entryType === 'advance' || entry.category === 'booking_diary_advance') {
      result.totalPaid += amount;
      const mode = entry.paymentMode || 'Other'; result.paymentModes[mode] = roundMoney(toAmount(result.paymentModes[mode]) + amount);
    }
  }
  result.grandRevenue = roundMoney(result.grossRevenue - result.discount + result.gst);
  for (const field of Object.keys(result)) if (typeof result[field] === 'number') result[field] = roundMoney(result[field]);
  return result;
}
